var _clipPath, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuiltExampleAdvanced(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0.0 0.0 514.7769028871392 514.7769028871392",
    fill: "none",
    stroke: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "p.0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0l514.7769 0l0 514.7769l-514.7769 0l0 -514.7769z",
    clipRule: "nonzero"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p.0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    fillOpacity: 0,
    d: "m0 0l514.7769 0l0 514.7769l-514.7769 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m0.005249344 0.010498688l170.83464 0l0 170.83464l-170.83464 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m0.005249344 0.010498688l170.83464 0l0 170.83464l-170.83464 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m0.005249344 0.010498688l47.27559 0l0 47.275593l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m0.005249344 0.010498688l47.27559 0l0 47.275593l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m0.005249344 123.560936l47.27559 0l0 47.27558l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m0.005249344 123.560936l47.27559 0l0 47.27558l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m123.56001 0.010498688l47.27559 0l0 47.275593l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m123.56001 0.010498688l47.27559 0l0 47.275593l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m123.56001 123.560936l47.27559 0l0 47.27558l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m123.56001 123.560936l47.27559 0l0 47.27558l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m47.27988 0.010498688l76.28346 0l0 47.275593l-76.28346 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m47.27988 0.010498688l76.28346 0l0 47.275593l-76.28346 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m47.27988 123.560936l76.28346 0l0 47.27558l-76.28346 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m47.27988 123.560936l76.28346 0l0 47.27558l-76.28346 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m0.005249344 123.56454l0 -76.28346l47.27559 0l0 76.28346z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m0.005249344 123.56454l0 -76.28346l47.27559 0l0 76.28346z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m170.83464 47.285133l0 76.28346l-47.27559 0l0 -76.28346z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.83464 47.285133l0 76.28346l-47.27559 0l0 -76.28346z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m123.56001 47.28609l0 -47.275593l47.27559 47.275593z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m123.56001 47.28609l0 -47.275593l47.27559 47.275593z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m123.55905 123.560936l47.27559 0l-47.27559 47.27558z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m123.55905 123.560936l47.27559 0l-47.27559 47.27558z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m0.005249344 170.83652l0 -47.27558l47.27559 47.27558z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m0.005249344 170.83652l0 -47.27558l47.27559 47.27558z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m0.004291601 0.010498688l47.27559 0l-47.27559 47.275593z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m0.004291601 0.010498688l47.27559 0l-47.27559 47.275593z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m47.27988 170.83652l38.141735 -47.27558l38.14173 47.27558z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m47.27988 170.83652l38.141735 -47.27558l38.14173 47.27558z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m0.004291601 47.28441l47.27559 38.14173l-47.27559 38.14173z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m0.004291601 47.28441l47.27559 38.14173l-47.27559 38.14173z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m123.56001 0.009540945l-38.14173 47.275593l-38.141735 -47.275593z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m123.56001 0.009540945l-38.14173 47.275593l-38.141735 -47.275593z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m170.8356 123.56526l-47.27559 -38.14173l47.27559 -38.14173z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.8356 123.56526l-47.27559 -38.14173l47.27559 -38.14173z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m170.83464 0.005249344l170.83464 0l0 170.83464l-170.83464 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.83464 0.005249344l170.83464 0l0 170.83464l-170.83464 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m170.83464 0.005249344l47.27559 0l0 47.27559l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.83464 0.005249344l47.27559 0l0 47.27559l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m170.83464 123.55569l47.27559 0l0 47.27558l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.83464 123.55569l47.27559 0l0 47.27558l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m294.3894 0.005249344l47.275604 0l0 47.27559l-47.275604 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m294.3894 0.005249344l47.275604 0l0 47.27559l-47.275604 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m294.3894 123.55569l47.275604 0l0 47.27558l-47.275604 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m294.3894 123.55569l47.275604 0l0 47.27558l-47.275604 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m218.10928 0.005249344l76.28345 0l0 47.27559l-76.28345 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m218.10928 0.005249344l76.28345 0l0 47.27559l-76.28345 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m218.10928 123.55569l76.28345 0l0 47.27558l-76.28345 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m218.10928 123.55569l76.28345 0l0 47.27558l-76.28345 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m170.83464 123.55929l0 -76.28346l47.27559 0l0 76.28346z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.83464 123.55929l0 -76.28346l47.27559 0l0 76.28346z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m341.66403 47.27988l0 76.28346l-47.275574 0l0 -76.28346z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m341.66403 47.27988l0 76.28346l-47.275574 0l0 -76.28346z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m294.3894 47.280838l0 -47.27559l47.275604 47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m294.3894 47.280838l0 -47.27559l47.275604 47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m294.38846 123.55569l47.275574 0l-47.275574 47.27558z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m294.38846 123.55569l47.275574 0l-47.275574 47.27558z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m170.83464 170.83127l0 -47.27558l47.27559 47.27558z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.83464 170.83127l0 -47.27558l47.27559 47.27558z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m170.8337 0.005249344l47.27559 0l-47.27559 47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.8337 0.005249344l47.27559 0l-47.27559 47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m218.10928 170.83127l38.141724 -47.27558l38.141724 47.27558z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m218.10928 170.83127l38.141724 -47.27558l38.141724 47.27558z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m170.8337 47.27916l47.27559 38.14173l-47.27559 38.14173z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.8337 47.27916l47.27559 38.14173l-47.27559 38.14173z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m294.3894 0.004291601l-38.141724 47.27559l-38.14174 -47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m294.3894 0.004291601l-38.141724 47.27559l-38.14174 -47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m341.665 123.56001l-47.275604 -38.14173l47.275604 -38.141735z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m341.665 123.56001l-47.275604 -38.14173l47.275604 -38.141735z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m341.66403 0l170.83463 0l0 170.83464l-170.83463 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m341.66403 0l170.83463 0l0 170.83464l-170.83463 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m341.66403 0l47.275604 0l0 47.27559l-47.275604 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m341.66403 0l47.275604 0l0 47.27559l-47.275604 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m341.66403 123.55044l47.275604 0l0 47.27558l-47.275604 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m341.66403 123.55044l47.275604 0l0 47.27558l-47.275604 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m465.2188 0l47.275574 0l0 47.27559l-47.275574 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m465.2188 0l47.275574 0l0 47.27559l-47.275574 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m465.2188 123.55044l47.275574 0l0 47.27558l-47.275574 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m465.2188 123.55044l47.275574 0l0 47.27558l-47.275574 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m388.93866 0l76.28348 0l0 47.27559l-76.28348 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m388.93866 0l76.28348 0l0 47.27559l-76.28348 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m388.93866 123.55044l76.28348 0l0 47.27558l-76.28348 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m388.93866 123.55044l76.28348 0l0 47.27558l-76.28348 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m341.66403 123.55404l0 -76.28346l47.275604 0l0 76.28346z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m341.66403 123.55404l0 -76.28346l47.275604 0l0 76.28346z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m512.4934 47.27463l0 76.28346l-47.275574 0l0 -76.28346z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m512.4934 47.27463l0 76.28346l-47.275574 0l0 -76.28346z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m465.2188 47.27559l0 -47.27559l47.275574 47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m465.2188 47.27559l0 -47.27559l47.275574 47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m465.21783 123.55044l47.275574 0l-47.275574 47.27558z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m465.21783 123.55044l47.275574 0l-47.275574 47.27558z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m341.66403 170.82602l0 -47.27558l47.275604 47.27558z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m341.66403 170.82602l0 -47.27558l47.275604 47.27558z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m341.6631 0l47.275574 0l-47.275574 47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m341.6631 0l47.275574 0l-47.275574 47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m388.93866 170.82602l38.141754 -47.27558l38.141724 47.27558z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m388.93866 170.82602l38.141754 -47.27558l38.141724 47.27558z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m341.6631 47.27391l47.275574 38.14173l-47.275574 38.14173z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m341.6631 47.27391l47.275574 38.14173l-47.275574 38.14173z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m465.2188 -9.577428E-4l-38.141724 47.27559l-38.141754 -47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m465.2188 -9.577428E-4l-38.141724 47.27559l-38.141754 -47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m512.4944 123.55476l-47.275574 -38.14173l47.275574 -38.141735z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m512.4944 123.55476l-47.275574 -38.14173l47.275574 -38.141735z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m0 170.84514l170.83464 0l0 170.83464l-170.83464 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m0 170.84514l170.83464 0l0 170.83464l-170.83464 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m0 170.84514l47.27559 0l0 47.27559l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m0 170.84514l47.27559 0l0 47.27559l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m0 294.39557l47.27559 0l0 47.275604l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m0 294.39557l47.27559 0l0 47.275604l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m123.55476 170.84514l47.27559 0l0 47.27559l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m123.55476 170.84514l47.27559 0l0 47.27559l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m123.55476 294.39557l47.27559 0l0 47.275604l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m123.55476 294.39557l47.27559 0l0 47.275604l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m47.27463 170.84514l76.28346 0l0 47.27559l-76.28346 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m47.27463 170.84514l76.28346 0l0 47.27559l-76.28346 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m47.27463 294.39557l76.28346 0l0 47.275604l-76.28346 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m47.27463 294.39557l76.28346 0l0 47.275604l-76.28346 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m0 294.3992l0 -76.28348l47.27559 0l0 76.28348z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m0 294.3992l0 -76.28348l47.27559 0l0 76.28348z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m170.82939 218.11978l0 76.28345l-47.27559 0l0 -76.28345z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.82939 218.11978l0 76.28345l-47.27559 0l0 -76.28345z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m123.55476 218.12073l0 -47.27559l47.27559 47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m123.55476 218.12073l0 -47.27559l47.27559 47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m123.5538 294.39557l47.27559 0l-47.27559 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m123.5538 294.39557l47.27559 0l-47.27559 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m0 341.67117l0 -47.275604l47.27559 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m0 341.67117l0 -47.275604l47.27559 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m-9.577428E-4 170.84514l47.27559 0l-47.27559 47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m-9.577428E-4 170.84514l47.27559 0l-47.27559 47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m47.27463 341.67117l38.141735 -47.275604l38.14173 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m47.27463 341.67117l38.141735 -47.275604l38.14173 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m-9.577428E-4 218.11905l47.27559 38.141724l-47.27559 38.141754z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m-9.577428E-4 218.11905l47.27559 38.141724l-47.27559 38.141754z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m123.55476 170.8442l-38.14173 47.27559l-38.141735 -47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m123.55476 170.8442l-38.14173 47.27559l-38.141735 -47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m170.83035 294.3999l-47.27559 -38.141724l47.27559 -38.14174z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.83035 294.3999l-47.27559 -38.141724l47.27559 -38.14174z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m170.82939 170.83989l170.83464 0l0 170.83464l-170.83464 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.82939 170.83989l170.83464 0l0 170.83464l-170.83464 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m170.82939 170.83989l47.27559 0l0 47.27559l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.82939 170.83989l47.27559 0l0 47.27559l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m170.82939 294.39032l47.27559 0l0 47.275604l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.82939 294.39032l47.27559 0l0 47.275604l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m294.38416 170.83989l47.275604 0l0 47.27559l-47.275604 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m294.38416 170.83989l47.275604 0l0 47.27559l-47.275604 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m294.38416 294.39032l47.275604 0l0 47.275604l-47.275604 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m294.38416 294.39032l47.275604 0l0 47.275604l-47.275604 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m218.10403 170.83989l76.28345 0l0 47.27559l-76.28345 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m218.10403 170.83989l76.28345 0l0 47.27559l-76.28345 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m218.10403 294.39032l76.28345 0l0 47.275604l-76.28345 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m218.10403 294.39032l76.28345 0l0 47.275604l-76.28345 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m170.82939 294.39395l0 -76.28348l47.27559 0l0 76.28348z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.82939 294.39395l0 -76.28348l47.27559 0l0 76.28348z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m341.65878 218.11453l0 76.28345l-47.275574 0l0 -76.28345z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m341.65878 218.11453l0 76.28345l-47.275574 0l0 -76.28345z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m294.38416 218.11548l0 -47.27559l47.275604 47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m294.38416 218.11548l0 -47.27559l47.275604 47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m294.3832 294.39032l47.275574 0l-47.275574 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m294.3832 294.39032l47.275574 0l-47.275574 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m170.82939 341.66592l0 -47.275604l47.27559 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.82939 341.66592l0 -47.275604l47.27559 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m170.82845 170.83989l47.27559 0l-47.27559 47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.82845 170.83989l47.27559 0l-47.27559 47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m218.10403 341.66592l38.141724 -47.275604l38.141724 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m218.10403 341.66592l38.141724 -47.275604l38.141724 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m170.82845 218.1138l47.27559 38.141724l-47.27559 38.141754z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.82845 218.1138l47.27559 38.141724l-47.27559 38.141754z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m294.38416 170.83894l-38.141724 47.27559l-38.14174 -47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m294.38416 170.83894l-38.141724 47.27559l-38.14174 -47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m341.65976 294.39465l-47.275604 -38.141724l47.275604 -38.14174z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m341.65976 294.39465l-47.275604 -38.141724l47.275604 -38.14174z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m341.65878 170.83464l170.83463 0l0 170.83464l-170.83463 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m341.65878 170.83464l170.83463 0l0 170.83464l-170.83463 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m341.65878 170.83464l47.275604 0l0 47.27559l-47.275604 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m341.65878 170.83464l47.275604 0l0 47.27559l-47.275604 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m341.65878 294.38507l47.275604 0l0 47.275604l-47.275604 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m341.65878 294.38507l47.275604 0l0 47.275604l-47.275604 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m465.21356 170.83464l47.275574 0l0 47.27559l-47.275574 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m465.21356 170.83464l47.275574 0l0 47.27559l-47.275574 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m465.21356 294.38507l47.275574 0l0 47.275604l-47.275574 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m465.21356 294.38507l47.275574 0l0 47.275604l-47.275574 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m388.9334 170.83464l76.28348 0l0 47.27559l-76.28348 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m388.9334 170.83464l76.28348 0l0 47.27559l-76.28348 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m388.9334 294.38507l76.28348 0l0 47.275604l-76.28348 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m388.9334 294.38507l76.28348 0l0 47.275604l-76.28348 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m341.65878 294.3887l0 -76.28348l47.275604 0l0 76.28348z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m341.65878 294.3887l0 -76.28348l47.275604 0l0 76.28348z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m512.48816 218.10928l0 76.28345l-47.275574 0l0 -76.28345z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m512.48816 218.10928l0 76.28345l-47.275574 0l0 -76.28345z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m465.21356 218.11023l0 -47.27559l47.275574 47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m465.21356 218.11023l0 -47.27559l47.275574 47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m465.2126 294.38507l47.275574 0l-47.275574 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m465.2126 294.38507l47.275574 0l-47.275574 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m341.65878 341.66068l0 -47.275604l47.275604 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m341.65878 341.66068l0 -47.275604l47.275604 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m341.65784 170.83464l47.275574 0l-47.275574 47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m341.65784 170.83464l47.275574 0l-47.275574 47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m388.9334 341.66068l38.141754 -47.275604l38.141724 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m388.9334 341.66068l38.141754 -47.275604l38.141724 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m341.65784 218.10855l47.275574 38.141724l-47.275574 38.141754z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m341.65784 218.10855l47.275574 38.141724l-47.275574 38.141754z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m465.21356 170.8337l-38.141724 47.27559l-38.141754 -47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m465.21356 170.8337l-38.141724 47.27559l-38.141754 -47.27559z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m512.48914 294.3894l-47.275574 -38.141724l47.275574 -38.14174z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m512.48914 294.3894l-47.275574 -38.141724l47.275574 -38.14174z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m0 341.67978l170.83464 0l0 170.83469l-170.83464 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m0 341.67978l170.83464 0l0 170.83469l-170.83464 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m0 341.67978l47.27559 0l0 47.275604l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m0 341.67978l47.27559 0l0 47.275604l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m0 465.23022l47.27559 0l0 47.275574l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m0 465.23022l47.27559 0l0 47.275574l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m123.55476 341.67978l47.27559 0l0 47.275604l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m123.55476 341.67978l47.27559 0l0 47.275604l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m123.55476 465.23022l47.27559 0l0 47.275574l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m123.55476 465.23022l47.27559 0l0 47.275574l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m47.27463 341.67978l76.28346 0l0 47.275604l-76.28346 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m47.27463 341.67978l76.28346 0l0 47.275604l-76.28346 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m47.27463 465.23022l76.28346 0l0 47.275574l-76.28346 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m47.27463 465.23022l76.28346 0l0 47.275574l-76.28346 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m0 465.23383l0 -76.28345l47.27559 0l0 76.28345z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m0 465.23383l0 -76.28345l47.27559 0l0 76.28345z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m170.82939 388.95444l0 76.28345l-47.27559 0l0 -76.28345z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.82939 388.95444l0 76.28345l-47.27559 0l0 -76.28345z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m123.55476 388.95538l0 -47.275604l47.27559 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m123.55476 388.95538l0 -47.275604l47.27559 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m123.5538 465.23022l47.27559 0l-47.27559 47.275574z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m123.5538 465.23022l47.27559 0l-47.27559 47.275574z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m0 512.5058l0 -47.275574l47.27559 47.275574z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m0 512.5058l0 -47.275574l47.27559 47.275574z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m-9.577428E-4 341.67978l47.27559 0l-47.27559 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m-9.577428E-4 341.67978l47.27559 0l-47.27559 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m47.27463 512.5058l38.141735 -47.275574l38.14173 47.275574z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m47.27463 512.5058l38.141735 -47.275574l38.14173 47.275574z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m-9.577428E-4 388.9537l47.27559 38.141724l-47.27559 38.141724z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m-9.577428E-4 388.9537l47.27559 38.141724l-47.27559 38.141724z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m123.55476 341.67883l-38.14173 47.275604l-38.141735 -47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m123.55476 341.67883l-38.14173 47.275604l-38.141735 -47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m170.83035 465.23456l-47.27559 -38.141724l47.27559 -38.141754z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.83035 465.23456l-47.27559 -38.141724l47.27559 -38.141754z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m170.82414 341.68503l170.83464 0l0 170.83469l-170.83464 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.82414 341.68503l170.83464 0l0 170.83469l-170.83464 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m170.82414 341.68503l47.27559 0l0 47.275604l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.82414 341.68503l47.27559 0l0 47.275604l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m170.82414 465.23547l47.27559 0l0 47.275574l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.82414 465.23547l47.27559 0l0 47.275574l-47.27559 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m294.3789 341.68503l47.275604 0l0 47.275604l-47.275604 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m294.3789 341.68503l47.275604 0l0 47.275604l-47.275604 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m294.3789 465.23547l47.275604 0l0 47.275574l-47.275604 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m294.3789 465.23547l47.275604 0l0 47.275574l-47.275604 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m218.09879 341.68503l76.28345 0l0 47.275604l-76.28345 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m218.09879 341.68503l76.28345 0l0 47.275604l-76.28345 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m218.09879 465.23547l76.28345 0l0 47.275574l-76.28345 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m218.09879 465.23547l76.28345 0l0 47.275574l-76.28345 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m170.82414 465.23907l0 -76.28345l47.27559 0l0 76.28345z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.82414 465.23907l0 -76.28345l47.27559 0l0 76.28345z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m341.65353 388.9597l0 76.28345l-47.275574 0l0 -76.28345z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m341.65353 388.9597l0 76.28345l-47.275574 0l0 -76.28345z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m294.3789 388.96063l0 -47.275604l47.275604 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m294.3789 388.96063l0 -47.275604l47.275604 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m294.37796 465.23547l47.275574 0l-47.275574 47.275574z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m294.37796 465.23547l47.275574 0l-47.275574 47.275574z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m170.82414 512.51105l0 -47.275574l47.27559 47.275574z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.82414 512.51105l0 -47.275574l47.27559 47.275574z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m170.8232 341.68503l47.27559 0l-47.27559 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.8232 341.68503l47.27559 0l-47.27559 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m218.09879 512.51105l38.141724 -47.275574l38.141724 47.275574z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m218.09879 512.51105l38.141724 -47.275574l38.141724 47.275574z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m170.8232 388.95895l47.27559 38.141724l-47.27559 38.141724z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m170.8232 388.95895l47.27559 38.141724l-47.27559 38.141724z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m294.3789 341.68408l-38.141724 47.275604l-38.14174 -47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m294.3789 341.68408l-38.141724 47.275604l-38.14174 -47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m341.6545 465.2398l-47.275604 -38.141724l47.275604 -38.141754z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m341.6545 465.2398l-47.275604 -38.141724l47.275604 -38.141754z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m341.6483 341.67978l170.83463 0l0 170.83469l-170.83463 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m341.6483 341.67978l170.83463 0l0 170.83469l-170.83463 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m341.6483 341.67978l47.275604 0l0 47.275604l-47.275604 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m341.6483 341.67978l47.275604 0l0 47.275604l-47.275604 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m341.6483 465.23022l47.275604 0l0 47.275574l-47.275604 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m341.6483 465.23022l47.275604 0l0 47.275574l-47.275604 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m465.20306 341.67978l47.275574 0l0 47.275604l-47.275574 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m465.20306 341.67978l47.275574 0l0 47.275604l-47.275574 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m465.20306 465.23022l47.275574 0l0 47.275574l-47.275574 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m465.20306 465.23022l47.275574 0l0 47.275574l-47.275574 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m388.9229 341.67978l76.28348 0l0 47.275604l-76.28348 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m388.9229 341.67978l76.28348 0l0 47.275604l-76.28348 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m388.9229 465.23022l76.28348 0l0 47.275574l-76.28348 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m388.9229 465.23022l76.28348 0l0 47.275574l-76.28348 0z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m341.6483 465.23383l0 -76.28345l47.275604 0l0 76.28345z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m341.6483 465.23383l0 -76.28345l47.275604 0l0 76.28345z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m512.47766 388.95444l0 76.28345l-47.275574 0l0 -76.28345z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m512.47766 388.95444l0 76.28345l-47.275574 0l0 -76.28345z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m465.20306 388.95538l0 -47.275604l47.275574 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m465.20306 388.95538l0 -47.275604l47.275574 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#66b371",
    d: "m465.2021 465.23022l47.275574 0l-47.275574 47.275574z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m465.2021 465.23022l47.275574 0l-47.275574 47.275574z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m341.6483 512.5058l0 -47.275574l47.275604 47.275574z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m341.6483 512.5058l0 -47.275574l47.275604 47.275574z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m341.64734 341.67978l47.275574 0l-47.275574 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m341.64734 341.67978l47.275574 0l-47.275574 47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m388.9229 512.5058l38.141754 -47.275574l38.141724 47.275574z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m388.9229 512.5058l38.141754 -47.275574l38.141724 47.275574z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m341.64734 388.9537l47.275574 38.141724l-47.275574 38.141724z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m341.64734 388.9537l47.275574 38.141724l-47.275574 38.141724z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m465.20306 341.67883l-38.141724 47.275604l-38.141754 -47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m465.20306 341.67883l-38.141724 47.275604l-38.141754 -47.275604z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ebf4fc",
    d: "m512.47864 465.23456l-47.275574 -38.141724l47.275574 -38.141754z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000000",
    strokeWidth: 1,
    strokeLinejoin: "round",
    strokeLinecap: "butt",
    d: "m512.47864 465.23456l-47.275574 -38.141724l47.275574 -38.141754z",
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiltExampleAdvanced);
export default __webpack_public_path__ + "static/media/QuiltExample_Advanced.93629321c284124aefc6c32253c23296.svg";
export { ForwardRef as ReactComponent };